export default "__VITE_ASSET__NMi9EYJu__"